<template>
  <div>
    <el-row>
      <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4'>
        <registry-admin-menu @addUniversity='addUniversityEvent' @addNewUniversity='addNewUniversityEvent'>
        </registry-admin-menu>
      </el-col>
      <el-col :xs='24' :sm='24' :md='16' :lg='16' :xl='16'>
        <search-uni v-show="searchUniVisible"></search-uni>
        <manage-db :addUniversity='addUniversity' v-if='addUniversity' @hideForm='hideForm'></manage-db>
        <manage-new-institutes :addUniversity='addNewUniversity' v-if='addNewUniversity' @hideForm='hideNewForm'></manage-new-institutes>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RegistryAdminMenu from './roleSpecific/RegistryAdminMenu'
import ManageDb from './roleSpecific/ManageDb'
import SearchUni from '@/components/common/SearchUni'
import ManageNewInstitutes from './roleSpecific/ManageNewInstitutes.vue'

export default {
  name: 'RegistryAdmin',
  components: {
    ManageDb,
    ManageNewInstitutes,
    RegistryAdminMenu,
    SearchUni
  },
  data () {
    return {
      addUniversity: false,
      addNewUniversity: false
    }
  },
  methods: {
    hideForm () {
      this.addUniversity = false
    },
    hideNewForm () {
      this.addNewUniversity = false
    },
    addUniversityEvent () {
      this.addUniversity = !this.addUniversity
    },
    addNewUniversityEvent () {
      this.addNewUniversity = !this.addNewUniversity
    }
  },
  computed: {
    ...mapState([
      'searchUniVisible',
      'BASE_URL'
    ])
  }
}
</script>

<style lang="scss">
.list-group {
  min-height: 20px;
}

.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegistryAdmin.vue